import { Category } from '@@partner:types:app'
import React, { useCallback } from 'react'

import {
  useSortable,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import SortIcon from '@rsuite/icons/Sort'
import { Button, SelectPicker } from 'rsuite'
import { GQL_ID } from '@@partner:types:graphql'
import DropzoneUploader from '@components/common/form/DropzoneUploader'
import { API_URL_UPLOAD_CATEGORY_ICON } from '@@partner:config/api'
import { UPLOAD_NAME_CATEGORY_ICON } from '@@partner:config/category'
import { generatePath, Link, useParams } from 'react-router-dom'
import { ROUTE_CATALOG_CATEGORY_EDIT } from '@@partner:config/routes'
import { Edit } from '@rsuite/icons'


type CategoryItemProps = {
  category: Category
  onChange: (category: Category) => void
  isSelected?: boolean
  onSelect?: (category: Category) => void
}

type PickerSize = {
  label: string
  value: string
}

const pickerSize: PickerSize[] = [
  { label: 'Обычный', value: 'standard' },
  { label: 'Двойной', value: 'double' },
  { label: 'Большой', value: 'big' }
]

export default function CategoryItem ({
  category,
  onChange,
  isSelected = false,
  onSelect
}: CategoryItemProps) {
  const { brandSlug } = useParams<any>()
  const [ requireSave, setRequireSave ] = React.useState(false)

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: category.id,
  })


  const style = {
    ...(category.icon?.url ? { backgroundImage: `url(${category.icon.url})` } : {}),
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const handleChange = useCallback((values: Partial<Category>) => {
    setRequireSave(true)
    onChange({
      ...category,
      ...values
    })
  }, [ onChange, category ])
  
  const handleUploadIcon = useCallback((
    icon_id: GQL_ID,
    url: string
  ) => {
    handleChange({
      icon_id: icon_id,
      icon: {
        url
      }
    })
    
  }, [ handleChange ])
  
  const handleCategoryClick = useCallback(() => {
    if (onSelect) {
      onSelect(category)
    }
  }, [ onSelect, category ])

  const editCategoryPath = generatePath(
    ROUTE_CATALOG_CATEGORY_EDIT,
    {
      brandSlug,
      categoryId: category.id
    }
  )
  
  return (
    <div
      ref={setNodeRef}
      className={`CategoryItem CategoryItem--${category.preview_size ?? 'standard'}${isSelected ? ' CategoryItem--selected' : ''}`}
      style={ style }
      onClick={handleCategoryClick}
    >
      <div
        {...attributes}
        {...listeners}
        className='CategoryItem__header'
      >
        <div><SortIcon style={{ fontSize: '1.15rem' }} /></div>
        <h1 className="u-heading">{category.name}</h1>
        <Link to={editCategoryPath} target='_blank'>
          <Button appearance="link"><Edit /></Button>
        </Link>
        
      </div>
      <div className="CategoryItem__content">
        <div className='CategoryItem__content--order'>
          <label style={{ marginRight: 8, fontWeight: 500 }}>Размер</label>
          <SelectPicker
            data={pickerSize}
            value={category.preview_size ?? 'standard'}
            onChange={(value) => {
              handleChange({
                preview_size: value ?? 'standard'
              })
            }}
            style={{ width: 180 }}
            placeholder="Размер превью"
          />
        </div>
        <DropzoneUploader
          action={API_URL_UPLOAD_CATEGORY_ICON}
          name={UPLOAD_NAME_CATEGORY_ICON}
          onUploaded={handleUploadIcon}
          multiple={false}
          containerStyle={{
            height: 50,
            minHeight: undefined,
            width: 250
          }}
        />
        <Button
          appearance='link'
          onClick={handleCategoryClick}
        >Показать подкатегории</Button>
      </div>
    </div>
  )
}